import React, { useState, useEffect } from 'react';
import { Button, Offcanvas } from 'react-bootstrap';
import { ModuleTitle } from './utilities/ModuleTitle.tsx';
import { MorphDetailModal } from './utilities/MorphDetailModal.tsx';
import { SuggestMorphModal } from './utilities/SuggestMorphModal.tsx';
import { SuggestSpeciesModal } from './utilities/SuggestSpeciesModal.tsx';
import { SuggestGeneModal } from './utilities/SuggestGeneModal.tsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass, faHome, faQuestion, faTimes, faPlus } from '@fortawesome/free-solid-svg-icons'
import { GeneInput } from './utilities/GeneInput.tsx';
import { MorphOrSpecies } from './utilities/MorphOrSpecies.tsx';
import { Gene } from '../types/Gene';
import { driver } from 'driver.js'
import { Reptile } from '../types/Reptile.ts';
import { Morph } from '../types/Morph.ts';
import { useRepToolContext } from '../RepToolContext.tsx';

const SlideOutControls = ({
  genes,
  morphSearch,
  geneSearch,
  isSpecies,
  setSearchExplaination,
  morphs
}: {
  genes: Gene[],
  morphs: Morph[],
  morphSearch: (morphSearch: string, exact: boolean) => void,
  geneSearch: (genesSearch: Gene[], exact: boolean) => void,
  setSearchExplaination: (explaination: string | null) => void,
  isSpecies: boolean
}) => {
  const [morphFilterVisible, setMorphFilterVisible] = useState(true);
  const [geneFilterVisible, setGeneFilterVisible] = useState(false);
  const [morphFilter, setMorphFilter] = useState('');
  const [exactMorph, setExactMorph] = useState(false);
  const [exactGene, setExactGene] = useState(false);
  const [selectedGenes, setSelectedGenes] = useState([{ gene_name: '', gene_type: '' }]);
  const setGenes = (gene, index) => {
    let newGenes = [...selectedGenes];
    newGenes[index] = gene;
    setSelectedGenes(newGenes);
  }

  useEffect(() => {
    search();
  }, [genes, morphs])

  const search = () => {
    if ((morphFilter === '' && morphFilterVisible) || (selectedGenes.length === 0 && geneFilterVisible)) {
      setSearchExplaination(null);
      morphSearch('', false);
      return;
    }
    if (morphFilterVisible) {
      morphSearch(morphFilter, exactMorph);
      setSearchExplaination(`Searching for morphs ${exactMorph ? 'exactly' : 'partially'} matching "${morphFilter}"`);
    } else if (geneFilterVisible) {
      geneSearch(selectedGenes, exactGene);
      const geneNames = selectedGenes.map(gene => gene.gene_name).filter(name => name !== '');
      setSearchExplaination(`Searching for morphs that ${exactGene ? 'completely match' : 'have some of'} the following genes: "${geneNames.join(', ')}"`);
    }
  }


  return (
    <React.Fragment>
      <h3>Filter Criteria</h3>

      <div id="collection-container" className="d-flex flex-row switch-container">
        {!isSpecies && <div className="no-pad w-100 my-3 text-center">
          <ul role="tablist" className="ui-tabs-nav ml-0 nav-tabs nav ui-corner-all ui-helper-reset ui-helper-clearfix ui-widget-header">
            <li id="morph-label" onClick={() => { setMorphFilterVisible(true); setGeneFilterVisible(false) }} className={`w-50  nav-item ${morphFilterVisible ? 'ui-tabs-active' : ''} ui-state-active`}>
              <a className={`nav-link p-0 ${morphFilterVisible ? 'active' : ''}`} id="ui-id-1">
                Filter By <MorphOrSpecies isSpecies={isSpecies} /></a>
            </li>
            <li id="gene-label" onClick={() => { setGeneFilterVisible(true); setMorphFilterVisible(false) }} className={`w-50  nav-item ${geneFilterVisible ? 'ui-tabs-active' : ''} ui-state-active`}>
              <a className={`nav-link p-0 ${geneFilterVisible ? 'active' : ''}`}>Filter
                By Genes</a>
            </li>
          </ul>
        </div>}

      </div>

      {morphFilterVisible && <div id="male_container" className="w-100 d-flex flex-column">
        <h6>Filter By <MorphOrSpecies isSpecies={isSpecies} /> Name</h6>
        <div id="morph-search-bar" className=" no-pad" onChange={(event) => setMorphFilter(event.target.value)}>
          <input
            id="male-morph"
            placeholder={`Search by ${isSpecies ? 'Species' : 'Morph'}`}
            className="morphSelect combobox-container male ui-autocomplete-input"
          />
        </div>
        <div id="morph-radio-filters" className=" no-pad">
          <div className="d-flex flex-row">
            <input
              type="radio"
              name="morph-filter-radio"
              onClick={() => setExactMorph(false)}
              className="mr-2 "
              checked={!exactMorph}
            />
            <h6>Contains</h6>
          </div>
          <div className="d-flex flex-row">
            <input
              type="radio"
              name="morph-filter-radio"
              onClick={() => setExactMorph(true)}
              className="mr-2"
              checked={exactMorph}
            />
            <h6>Exact Match</h6>
          </div>
        </div>
        <Button variant="outline-light" id="morph-search-btn" onClick={search} className="mt-4">Search</Button>
      </div>}
      {geneFilterVisible && !isSpecies && <div id="gene-filter-container" className=" no-pad">
        <h6>Filter By Genes</h6>
        <div id="gene-selects">
          {
            selectedGenes.map((gene, index) => (
              <GeneInput
                id={`gene-input-${index}`}
                key={index}
                genes={genes}
                gene={gene}
                setGene={(geneData) => setGenes(geneData, index)}
                typeSwitch={false}
              />
            ))
          }
          <div
            id="gene-radio-filters"
            className="d-flex flex-column w-100"
          >
            <div className="d-flex flex-row">
              <input
                type="radio"
                onClick={() => setExactGene(false)}
                checked={!exactGene}
                name="gene-filter-radio"
                value="contains"
                className="mr-2"
              />
              <h6>Contains</h6>
            </div>
            <div className="d-flex flex-row">
              <input
                type="radio"
                onClick={() => setExactGene(true)}
                checked={exactGene}
                name="gene-filter-radio"
                className="mr-2"
                value="exact"
              />
              <h6>Exact Match</h6>
            </div>
          </div>
        </div>
        <Button
          variant='outline-light'
          className="back-to-calc"
          onClick={() => setSelectedGenes([...selectedGenes, { gene_name: '', gene_type: '' }])}
        >
          <FontAwesomeIcon icon={faPlus} className="mr-2" />
          Add More Gene Filters
        </Button>
        <Button variant='outline-light' id="gene-search-btn" onClick={search} className="mt-3 w-100">Search</Button>
      </div>}
    </React.Fragment>
  )
}

const MorphButton = ({ morph, morphs, userInfo, addControls, readOnly }) => {
  const [showDetailModal, setShowDetailModal] = useState(false);
  const { appendControls } = useRepToolContext();
  useEffect(() => {
    if (showDetailModal) {
      appendControls(null, "MorphButton");
    } else {
      addControls();
    }
  }, [showDetailModal])
  return (<>
    <div className="morph-button button py-2 w-100 mt-3" onClick={() => setShowDetailModal(true)}>{morph.name}</div>
    {showDetailModal && <MorphDetailModal
      morph={morph}
      morphs={morphs}
      readOnly={readOnly}
      userInfo={userInfo}
      closeModal={() => setShowDetailModal(false)}
    />}
  </>
  )
}

const BrowseButtons = ({ toggleSearch, backToMenu, toggleTutorial }: {
  toggleSearch: () => void,
  backToMenu: () => void,
  toggleTutorial: () => void
}) => {
  return (
    <div className='d-flex flex-row ml-auto'>
      <a className="text-white mr-4" onClick={() => toggleTutorial()}>
        <FontAwesomeIcon size='xl' icon={faQuestion} />
      </a>
      <a className="text-white mr-4" onClick={() => backToMenu()}>
        <FontAwesomeIcon size='xl' icon={faHome} />
      </a>
      <a id='search-btn' className="text-white" onClick={() => toggleSearch()}>
        <FontAwesomeIcon size='xl' icon={faMagnifyingGlass} />
      </a>

    </div>
  )
}

interface BrowseProps {
  morphs: Morph[],
  genes: Gene[],
  backToMenu: () => void,
  userInfo: any,
  readOnly: boolean,
  rep: Reptile
}

export const Browse = ({ morphs, genes, backToMenu, userInfo, readOnly, rep }: BrowseProps) => {
  const [showSuggestGene, setShowSuggestGene] = useState(false);
  const [showSuggestMorph, setShowSuggestMorph] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [currentMorphs, setCurrentMorphs] = useState(morphs);
  const [showSuggestSpecies, setShowSuggestSpecies] = useState(false);
  const [searchExplaination, setSearchExplanation] = useState<string | null>(null);
  const {appendControls} = useRepToolContext();
  const suggestVisible = rep.controls?.isSpecies ? [
    { element: '#suggest-species', popover: { title: 'Suggest a Species', description: `Here you can suggest a new species to be added to the RepTool\'s list for ${rep.reptile_name}.` } },
  ] : [
    { element: '#suggest-gene', popover: { title: 'Suggest a gene', description: `Here you can suggest a new gene to be added to RepTool\'s list for ${rep.reptile_name}.` } },
    { element: '#suggest-morph', popover: { title: 'Suggest a morph', description: `Here you can suggest a new morph to be added to RepTool\'s list for ${rep.reptile_name}.` } },
  ]


  const morphSearch = (morphSearch, exact) => {
    let newMorphs: Morph[] = [];
    if (morphSearch === "") {
      setCurrentMorphs(morphs);
      return;
    }
    if (exact) {
      newMorphs = morphs.filter((morph) => morph.name.toLowerCase() === morphSearch.toLowerCase());

    } else {
      newMorphs = morphs.filter((morph) => {
        return (morph.name).toLowerCase().includes(morphSearch.toLowerCase())
      });
      // sort by how close the match is to the search term by checking the length of the morph name
      newMorphs = newMorphs.sort((a, b) => {
        const aLength = a.name.toLowerCase().indexOf(morphSearch.toLowerCase());
        const bLength = b.name.toLowerCase().indexOf(morphSearch.toLowerCase());
        return aLength - bLength;
      });
    }
    setCurrentMorphs(newMorphs);
  }
  const geneSearch = (genesSearch, exact) => {
    let newMorphs: Morph[] = [];
    genesSearch = genesSearch.filter(gene => gene.gene_name !== "");
    genesSearch = genesSearch.map(singleSearch => { return { gene_name: singleSearch.gene_name, gene_type: singleSearch.gene_type } });
    if (exact) {
      newMorphs = morphs.filter((morph) => {
        return morph.genes.length === genesSearch.length && genesSearch.every(singleSearch => morph.genes.find((singleGene) => singleGene.gene_name.toLowerCase() === singleSearch.gene_name.toLowerCase()));
      });
    } else {

      newMorphs = morphs.filter((morph) => {
        return genesSearch.every(singleSearch => morph.genes.find((singleGene) => singleGene.gene_name.toLowerCase() === singleSearch.gene_name.toLowerCase()));
      });

    }
    setCurrentMorphs(newMorphs);
  }

  const addControls = () => {
    const browseDriverObj = driver({
      steps: [
        { element: '#suggest-container', popover: { title: 'Suggest a Morph, Gene, or Species', description: 'If you can\'t find the morph/gene/species you are looking for in this app you can use these buttons to suggest one. A moderator will review your suggestion and verify the info is correct. You\'ll even be rewarded with RepTool scales for your contribution!' } },
        ...suggestVisible,
        { element: '#search-btn', popover: { title: 'Search', description: 'If you want to narrow down this list you can click here to filter the list by morph name or genes.' } }
      ]
    });
    appendControls(<BrowseButtons toggleSearch={() => setShowSearch(!showSearch)} backToMenu={backToMenu} toggleTutorial={() => browseDriverObj.drive()} />, "Browse");
  }

  useEffect(() => {
    if (showSearch || showSuggestMorph || showSuggestGene) {
      appendControls(null, "Search or Suggest");
    } else {
      addControls();
    }
  }, [showSearch, showSuggestMorph, showSuggestGene])

  useEffect(() => {
    if (!showSearch && currentMorphs.length === 0) {
      setCurrentMorphs(morphs);
    }
  }, [morphs])

  return (
    <div className='fadeIn animated'>

      <Offcanvas className='bg-black border-right px-4 text-light' show={showSearch} onHide={() => setShowSearch(false)}>
        <Offcanvas.Header className='text-light d-flex justify-content-end' >
          <div onClick={() => setShowSearch(false)} className='close-canvas'>
            <FontAwesomeIcon icon={faTimes} size='2x' style={{
              cursor: 'pointer'
            }} />
          </div>
        </Offcanvas.Header>
        <SlideOutControls isSpecies={rep.controls?.isSpecies || false} genes={genes} geneSearch={geneSearch} morphSearch={morphSearch} morphs={morphs} setSearchExplaination={setSearchExplanation} />
      </Offcanvas>

      <ModuleTitle title={`Browse ${rep.controls?.isSpecies ? 'Species' : 'Morphs'}`} backToMenu={backToMenu} />

      <div id='suggest-container' className="px-3 border-bottom pb-3">
        <h6>Suggest a:</h6>
        <div className="d-flex flex-row">
          {!rep.controls?.isSpecies ? <React.Fragment>
            <div id='suggest-gene' onClick={() => setShowSuggestGene(true)} className="text-center button w-100 mt-1">Gene</div>
            <div id='suggest-morph' onClick={() => setShowSuggestMorph(true)} className="text-center button w-100 ml-2 mt-1">
              Morph
            </div>
          </React.Fragment>
            :
            <div id='suggest-species' onClick={() => setShowSuggestSpecies(true)} className="text-center button w-100 ml-2 mt-1">Species</div>
          }
        </div>
      </div>
      {searchExplaination && <div className='ml-4 mt-2 d-flex'>
        <FontAwesomeIcon icon={faTimes} size='2x' onClick={() => {
          setSearchExplanation(null);
          setCurrentMorphs(morphs);
        }} className='mr-2'
          style={{
            cursor: 'pointer'
          }}
        />
        <span className='text-light my-auto ml-2'>
          {searchExplaination}
        </span>
      </div>}
      <div className='px-4 pb-5'>
        {currentMorphs.map((morph) => (
          <MorphButton
            key={morph.id}
            morphs={morphs}
            morph={morph}
            userInfo={userInfo}
            addControls={addControls}
            readOnly={readOnly}
          />
        ))}
      </div>

      {showSuggestMorph && <SuggestMorphModal genes={genes} closeModal={() => setShowSuggestMorph(false)} />}
      {showSuggestGene && <SuggestGeneModal closeModal={() => setShowSuggestGene(false)} />}
      {showSuggestSpecies && <SuggestSpeciesModal closeModal={() => setShowSuggestSpecies(false)} />}
    </div>
  )
}